(function () {
  'use strict';

  var player = null;
  var currentIndex = 0;
  var videos = [];
  var productId = '';
  var scrollY = 0;

  function init() {
    // Find the modal and move it to body so it's not trapped in a stacking context
    var $modal = $('.in-action-modal').first();
    if (!$modal.length) return;

    $modal.appendTo('body');

    productId = $modal.attr('id').replace('in-action-modal-', '');

    // Parse videos from whichever carousel we find first
    var $carousel = $('[data-section-type="in-action-video"]').first().find('.in-action__carousel');
    if ($carousel.length) {
      try {
        videos = JSON.parse($carousel.attr('data-videos'));
      } catch (e) {
        videos = [];
      }
    }

    if (!videos.length) return;

    bindEvents();
  }

  function openModal(index) {
    var $modal = $('#in-action-modal-' + productId);
    if (!$modal.length) return;

    scrollY = window.pageYOffset;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';

    // Hide Shopify chat widget
    document.querySelectorAll('inbox-online-store-chat, #ShopifyChat, [id*="ShopifyChat"]').forEach(function(el) {
      el.style.setProperty('visibility', 'hidden', 'important');
    });

    // Pause and hide inline carousel videos (iOS renders them above fixed overlays)
    document.querySelectorAll('.in-action__inline-video').forEach(function(v) {
      v.pause();
      v.style.setProperty('visibility', 'hidden', 'important');
    });

    $modal.addClass('is-active');
    loadVideo(index);
  }

  function closeModal() {
    var $modal = $('#in-action-modal-' + productId);
    $modal.removeClass('is-active');

    if (player) {
      player.pause();
    }

    var videoEl = document.getElementById('in-action-player-' + productId);
    if (videoEl) {
      videoEl.removeAttribute('src');
      videoEl.load();
    }

    // Restore Shopify chat widget
    document.querySelectorAll('inbox-online-store-chat, #ShopifyChat, [id*="ShopifyChat"]').forEach(function(el) {
      el.style.removeProperty('visibility');
    });

    // Restore and play all inline carousel videos
    document.querySelectorAll('.in-action__inline-video').forEach(function(v) {
      v.style.removeProperty('visibility');
    });
    setTimeout(function() {
      document.querySelectorAll('.in-action__inline-video').forEach(function(v) {
        v.play().catch(function() {});
      });
    }, 100);

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollY);
  }

  function loadVideo(index) {
    if (index < 0 || index >= videos.length) return;
    currentIndex = index;

    var videoEl = document.getElementById('in-action-player-' + productId);
    if (!videoEl) return;

    videoEl.src = videos[index].url;
    if (videos[index].poster) {
      videoEl.poster = videos[index].poster;
    }

    if (!player && typeof Plyr !== 'undefined') {
      player = new Plyr(videoEl, {
        controls: [],
        autoplay: true,
        muted: true,
        loop: { active: true },
        clickToPlay: true,
        hideControls: true
      });
    }

    if (player) {
      player.muted = true;
      player.play();
    } else {
      videoEl.muted = true;
      videoEl.play().catch(function () {});
    }

    updateNavState();
    updateMuteIcon();
  }

  function navigateVideo(direction) {
    var newIndex = currentIndex + direction;
    if (newIndex < 0 || newIndex >= videos.length) return;
    loadVideo(newIndex);
  }

  function updateNavState() {
    var $modal = $('#in-action-modal-' + productId);
    $modal.find('.in-action-modal__nav-btn--up').toggle(currentIndex > 0);
    $modal.find('.in-action-modal__nav-btn--down').toggle(currentIndex < videos.length - 1);
  }

  function toggleMute() {
    var videoEl = document.getElementById('in-action-player-' + productId);
    if (!videoEl) return;

    if (player) {
      player.muted = !player.muted;
    } else {
      videoEl.muted = !videoEl.muted;
    }

    updateMuteIcon();
  }

  function updateMuteIcon() {
    var videoEl = document.getElementById('in-action-player-' + productId);
    if (!videoEl) return;

    var isMuted = player ? player.muted : videoEl.muted;
    var $btn = $('#in-action-modal-' + productId).find('.in-action-modal__mute-btn');
    $btn.find('.icon-unmuted').css('display', isMuted ? 'none' : '');
    $btn.find('.icon-muted').css('display', isMuted ? '' : 'none');
  }

  function handleAddToCart(e) {
    e.preventDefault();
    // Sync variant selection to the main product form then submit it
    var pid = $(e.currentTarget).data('product-id') || productId;
    var $variant = $('#in-action-variant-' + pid);
    var variantId = $variant.val();

    if (variantId) {
      $('#product-form input[name="id"]').val(variantId);
    }

    closeModal();

    // Small delay to let modal close, then submit the main form
    setTimeout(function() {
      $('#product-form').submit();
    }, 150);
  }

  function handleBuyNow(e) {
    e.preventDefault();
    var pid = $(e.currentTarget).data('product-id') || productId;
    var $variant = $('#in-action-variant-' + pid);
    var variantId = $variant.val();

    if (variantId) {
      $('#product-form input[name="id"]').val(variantId);
    }

    closeModal();

    setTimeout(function() {
      $('#product-form').submit();
    }, 150);
  }

  function bindEvents() {
    var $modal = $('#in-action-modal-' + productId);

    // Open modal - delegated to document so it works for both mobile & desktop carousels
    $(document).on('click', '.in-action__thumb', function (e) {
      e.preventDefault();
      var index = parseInt($(this).data('video-index'), 10);
      openModal(index);
    });

    // Close modal
    $(document).on('click', '.in-action-modal__close, .in-action-modal__bg', function (e) {
      e.preventDefault();
      closeModal();
    });

    $(document).on('keydown', function (e) {
      if (e.key === 'Escape' && $modal.hasClass('is-active')) {
        closeModal();
      }
    });

    // Navigation
    $modal.on('click', '.in-action-modal__nav-btn--up', function () {
      navigateVideo(-1);
    });

    $modal.on('click', '.in-action-modal__nav-btn--down', function () {
      navigateVideo(1);
    });

    // Keyboard nav in modal
    $(document).on('keydown', function (e) {
      if (!$modal.hasClass('is-active')) return;
      if (e.key === 'ArrowUp') { navigateVideo(-1); e.preventDefault(); }
      if (e.key === 'ArrowDown') { navigateVideo(1); e.preventDefault(); }
    });

    // Touch swipe for mobile video navigation
    var touchStartY = 0;
    $modal.on('touchstart', '.in-action-modal__video-area', function (e) {
      touchStartY = e.originalEvent.touches[0].clientY;
    });

    $modal.on('touchend', '.in-action-modal__video-area', function (e) {
      var deltaY = touchStartY - e.originalEvent.changedTouches[0].clientY;
      if (Math.abs(deltaY) > 50) {
        navigateVideo(deltaY > 0 ? 1 : -1);
      }
    });

    // Mute
    $modal.on('click', '.in-action-modal__mute-btn', function () {
      toggleMute();
    });

    // Add to cart
    $modal.on('click', '.in-action-modal__add-to-cart', handleAddToCart);

    // Buy now
    $modal.on('click', '.in-action-modal__buy-now', handleAddToCart);

    // Mobile shop button
    $modal.on('click', '.in-action-modal__shop-btn', handleAddToCart);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
